import { useEffect } from 'react';

/**
 * Puts a class on `<html>` for as long as the component is mounted.
 *
 * There is exactly one thing this is for: a root font size. The live site's pages are ported class
 * for class, and one of them — `book.html` — sets `html { font-size: 15px }` and steps it up at
 * three breakpoints. Every length in that page's stylesheet is a `rem`, and a `rem` is root-relative
 * by definition, so scoping the page's rules under `.book-page` carries all of them *except* the
 * scale they are measured in. This is that exception, and nothing else belongs here.
 */
export function useRootClass(className: string): void {
    useEffect(() => {
        document.documentElement.classList.add(className);

        return () => document.documentElement.classList.remove(className);
    }, [className]);
}
